import React, { useState} from 'react'
import { LiaTimesSolid } from "react-icons/lia";
import logo from "../../../Assets/Images/Bloc-Logo.png";
import image1 from '../../../Assets/Images/image1.png';
import {Link } from 'react-router-dom'
import { useDispatch } from 'react-redux';
import {API} from '../../../Services/axios'
import {URLS} from '../../../Services/Urls';
import { setProjectData } from '../../../Redux/Store/Slices/projectReducer';
import { toast } from 'react-toastify';
import useSWR from 'swr';
 

const SelectProjet = () => {
  const [project_type, setProject_type] = useState('');
  const [name, setName] = useState('');
  // const [id, setId] = useState()
  const dispatch = useDispatch();
  const {id} = useSWR(URLS.PROJECT.createProject)

  const handleChange = (event) => {
    setProject_type(event.target.value);
  };

  const handleSelectProject = () => {
    console.log('project_type:', project_type);
    console.log('name:', name);
    console.log('id:', id)
    API.post(URLS.PROJECT.createProject, { project_type: project_type, name: project_type })
      .then((resp) => {
        dispatch(setProjectData(resp.data));
        localStorage.setItem('projectData', JSON.stringify(resp.data));
        console.log('Success Project Type:', project_type);
      })
      .catch((error) => {
        console.error('Error selecting project:', error);
        alert('There was an error selecting the project. Please try again.');
      });
  };

  return (
    <div>
      <div className="container-fluid overflow-hidden">
        <div className="row">
          <div className="col-lg-4 col-md-5 px-5 pt-5">
            <div className="mb-4">
              <img className="ml-5 logo-bloc" src={logo} alt="logo-bloc" />
            </div>
            <div className="py-5">
              <img className='illustration-1 rounded w-75' src={image1} alt="illustration" />
            </div>
            <div className='list-col'>
              <ul className="list-row fw-bold d-flex my-5 justify-content-center">
                <li className="px-3 border-end border-dark-50">Help</li>
                <li className="px-3 border-end border-dark-50">Terms & Condition</li>
                <li className="px-3">Privacy Policy</li>
              </ul>
            </div>
          </div>
          <div className="col-lg-8 col-md-7 bg-white p-5 ml-4">
            <div className="mb-5">
              <p className="fw-bold fs-3"><LiaTimesSolid /></p>
              <div className="title pt-2">
                <h1 className="">Titre du Projet</h1>
                <p className="fst-italic">NB: Vous pourrez modifier le titre du projet plustard si vous le souhaitez</p>
              </div>
            </div>
            <div>
              <div className="form-group">
                <select
                  id="dropdown"
                  className="form-control"
                  value={project_type}
                  onChange={handleChange}
                >
                  <option value="">Select a Projet</option>
                  <option value="TERASSE_EXTERIEUR">Terrasse extérieure</option>
                  <option value="BARDAGE">Bardage</option>
                  <option value="BARDAGE_EXTERIEUR">Bardage extérieur</option>
                  <option value="SOL">Sol</option>
                  <option value="MUR_PLAQUE_PLATRE">Mur PLAQUE PLATRE</option>
                </select>
                <div className="mt-2">
                  {/* <p className="form-text">You selected: {project_type}</p> */}
                </div>
              </div>
              <div className='d-flex justify-content-between progress-btn'>
                <span />
                <div>
                  <button type="button" className="btn button me-3">
                    <Link className='text-white fw-bold' to="/project">Back</Link>
                  </button>
                  <button  onClick={handleSelectProject} type="button" className="btn button-btn  text-white fw-bold"><Link className='text-white' to=":id">Next</Link></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectProjet;
